import LaunchIcon from '@mui/icons-material/Launch';
import { Link, Typography } from '@mui/material';
import { getSalesforceBookingLink } from '../../utils/helpers';
import { COLORS } from '../../utils/Application_Constants';

/**
 * Salesforce Booking link matching PTS / invoicing pattern (label + LaunchIcon).
 * When bookingSfId is null/empty, renders plain text label only (no link).
 */
export default function SalesforceBookingLink({
    bookingSfId,
    label,
    sx,
    typographySx,
    stopPropagation = false,
}) {
    if (!label) {
        return null;
    }

    if (!bookingSfId) {
        return (
            <Typography component="span" sx={typographySx} data-testid="salesforce-booking-label">
                {label}
            </Typography>
        );
    }

    return (
        <Link
            href={getSalesforceBookingLink(bookingSfId)}
            target="_blank"
            rel="noreferrer"
            underline="always"
            data-testid="salesforce-booking-link"
            onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                color: COLORS.LT_JOURNEY,
                width: 'fit-content',
                fontSize: 'inherit',
                fontStyle: 'inherit',
                lineHeight: 'inherit',
                ...sx,
            }}
        >
            {label}
            <LaunchIcon sx={{ fontSize: 17.5 }} />
        </Link>
    );
}
